//src/utils/pendentLoadShipmentAdapter.js
function toFiniteNumber(
  value
) {
  if (
    value ===
      null ||
    value ===
      undefined ||
    value ===
      ""
  ) {
    return null;
  }

  const numberValue =
    Number(
      String(
        value
      ).replace(
        ",",
        "."
      )
    );

  return Number.isFinite(
    numberValue
  )
    ? numberValue
    : null;
}

function normalizeCoordinatePair(
  firstValue,
  secondValue
) {
  const firstNumber =
    toFiniteNumber(
      firstValue
    );

  const secondNumber =
    toFiniteNumber(
      secondValue
    );

  if (
    firstNumber ===
      null ||
    secondNumber ===
      null
  ) {
    return null;
  }

  if (
    Math.abs(
      firstNumber
    ) <=
      90 &&
    Math.abs(
      secondNumber
    ) <=
      180
  ) {
    return {
      lat:
        firstNumber,

      lng:
        secondNumber,
    };
  }

  if (
    Math.abs(
      firstNumber
    ) <=
      180 &&
    Math.abs(
      secondNumber
    ) <=
      90
  ) {
    return {
      lat:
        secondNumber,

      lng:
        firstNumber,
    };
  }

  return null;
}

export function getPendentLoadPointCoordinates(
  point
) {
  if (
    !point
  ) {
    return null;
  }

  const directCoordinates =
    normalizeCoordinatePair(
      point.latitude ??
        point.lat,

      point.longitude ??
        point.lng ??
        point.lon
    );

  if (
    directCoordinates
  ) {
    return directCoordinates;
  }

  const coordinates =
    point.coordinates;

  if (
    Array.isArray(
      coordinates
    ) &&
    coordinates.length >=
      2
  ) {
    return normalizeCoordinatePair(
      coordinates[0],
      coordinates[1]
    );
  }

  if (
    coordinates &&
    typeof coordinates ===
      "object"
  ) {
    if (
      Array.isArray(
        coordinates.coordinates
      ) &&
      coordinates.coordinates.length >=
        2
    ) {
      return normalizeCoordinatePair(
        coordinates.coordinates[1],
        coordinates.coordinates[0]
      );
    }

    return normalizeCoordinatePair(
      coordinates.lat ??
        coordinates.latitude,

      coordinates.lng ??
        coordinates.lon ??
        coordinates.longitude
    );
  }

  const rawCoordinates =
    String(
      coordinates ||
        ""
    ).trim();

  if (
    !rawCoordinates
  ) {
    return null;
  }

  try {
    const parsedCoordinates =
      JSON.parse(
        rawCoordinates
      );

    return getPendentLoadPointCoordinates({
      ...point,

      coordinates:
        parsedCoordinates,
    });
  } catch {
    const matches =
      rawCoordinates.match(
        /-?\d+(?:\.\d+)?/g
      );

    if (
      !matches ||
      matches.length <
        2
    ) {
      return null;
    }

    return normalizeCoordinatePair(
      matches[0],
      matches[1]
    );
  }
}

function getPointDateHourValue(
  point
) {
  const dateMatch =
    String(
      point?.date ||
        ""
    ).match(
      /^(\d{4})-(\d{2})-(\d{2})$/
    );

  const hourMatch =
    String(
      point?.hour ||
        ""
    ).match(
      /^(\d{2}):(\d{2})$/
    );

  if (
    !dateMatch ||
    !hourMatch
  ) {
    return null;
  }

  const year =
    Number(
      dateMatch[1]
    );

  const month =
    Number(
      dateMatch[2]
    );

  const day =
    Number(
      dateMatch[3]
    );

  const hours =
    Number(
      hourMatch[1]
    );

  const minutes =
    Number(
      hourMatch[2]
    );

  if (
    month < 1 ||
    month > 12 ||
    day < 1 ||
    day > 31 ||
    hours < 0 ||
    hours > 23 ||
    minutes < 0 ||
    minutes > 59
  ) {
    return null;
  }

  return Date.UTC(
    year,
    month - 1,
    day,
    hours,
    minutes
  );
}

function compareWorkspaceStops(
  stopA,
  stopB
) {
  const dateHourA =
    getPointDateHourValue(
      stopA
    );

  const dateHourB =
    getPointDateHourValue(
      stopB
    );

  if (
    dateHourA !== null &&
    dateHourB !== null &&
    dateHourA !==
      dateHourB
  ) {
    return (
      dateHourA -
      dateHourB
    );
  }

  if (
    dateHourA !== null &&
    dateHourB === null
  ) {
    return -1;
  }

  if (
    dateHourA === null &&
    dateHourB !== null
  ) {
    return 1;
  }

  const sequenceA =
    toFiniteNumber(
      stopA
        ?.__sourceSequence ??
        stopA?.sequence
    );

  const sequenceB =
    toFiniteNumber(
      stopB
        ?.__sourceSequence ??
        stopB?.sequence
    );

  if (
    sequenceA !== null &&
    sequenceB !== null &&
    sequenceA !==
      sequenceB
  ) {
    return (
      sequenceA -
      sequenceB
    );
  }

  return (
    Number(
      stopA?.sequence ||
        0
    ) -
    Number(
      stopB?.sequence ||
        0
    )
  );
}

function normalizePendentLoadRouteViaPoints(
  routeViaPoints,
  stopCount
) {
  const safeStopCount =
    Number(
      stopCount
    );

  if (
    !Number.isFinite(
      safeStopCount
    ) ||
    safeStopCount <
      2
  ) {
    return [];
  }

  const maximumLegIndex =
    safeStopCount -
    2;

  const normalizedViaPoints =
    (
      Array.isArray(
        routeViaPoints
      )
        ? routeViaPoints
        : []
    )
      .map(
        (
          viaPoint,
          index
        ) => {
          const coordinates =
            getPendentLoadPointCoordinates(
              viaPoint
            );

          if (
            !coordinates
          ) {
            return null;
          }

          const rawLegIndex =
            toFiniteNumber(
              viaPoint
                ?.legIndex ??
                viaPoint
                  ?.segmentIndex
            );

          const legIndex =
            Math.min(
              Math.max(
                Math.trunc(
                  rawLegIndex ??
                    0
                ),
                0
              ),
              maximumLegIndex
            );

          const rawSequence =
            toFiniteNumber(
              viaPoint
                ?.sequence
            );

          return {
            ...viaPoint,

            id:
              String(
                viaPoint?.id ??
                  `route-via-${legIndex}-${index}`
              ),

            type:
              "VIA",

            legIndex,

            sequence:
              Math.max(
                Math.trunc(
                  rawSequence ??
                    0
                ),
                0
              ),

            lat:
              coordinates.lat,

            lng:
              coordinates.lng,

            latitude:
              coordinates.lat,

            longitude:
              coordinates.lng,
          };
        }
      )
      .filter(
        Boolean
      )
      .sort(
        (
          viaPointA,
          viaPointB
        ) => {
          if (
            viaPointA.legIndex !==
            viaPointB.legIndex
          ) {
            return (
              viaPointA.legIndex -
              viaPointB.legIndex
            );
          }

          return (
            viaPointA.sequence -
            viaPointB.sequence
          );
        }
      );

  const nextSequenceByLeg =
    new Map();

  return normalizedViaPoints.map(
    (
      viaPoint
    ) => {
      const sequence =
        nextSequenceByLeg.get(
          viaPoint.legIndex
        ) ||
        0;

      nextSequenceByLeg.set(
        viaPoint.legIndex,
        sequence +
          1
      );

      return {
        ...viaPoint,

        sequence,
      };
    }
  );
}

function normalizeWorkspaceStop(
  point,
  type,
  sourceIndex,
  sequence
) {
  const cleanType =
    String(
      type ||
        ""
    ).toUpperCase();

  return {
    ...point,

    __workspaceKey:
      [
        "pendent-load-stop",
        cleanType.toLowerCase(),
        point?.id ??
          sourceIndex,
      ].join(
        "-"
      ),

    __sourceType:
      cleanType,

    __sourceIndex:
      sourceIndex,

    __sourceSequence:
      toFiniteNumber(
        point?.sequence
      ),

    id:
      point?.id ??
      `${cleanType.toLowerCase()}-${sourceIndex}`,

    type:
      cleanType,

    sequence,

    placeName:
      point?.placeName ||
      point?.location ||
      "",

    location:
      point?.location ||
      point?.placeName ||
      "",

    phone:
      point?.phone ||
      point?.contactPhone ||
      "",

    contactPhone:
      point?.contactPhone ||
      point?.phone ||
      "",

    loadAccessMode:
      point?.loadAccessMode ||
      point?.loadingAccess ||
      "",

    loadingAccess:
      point?.loadingAccess ||
      point?.loadAccessMode ||
      "",
  };
}

export function buildPendentLoadWorkspaceStops(
  pickupPoints = [],
  deliveryPoints = [],
  {
    preserveGlobalSequence =
      false,
  } = {}
) {
  const safePickupPoints =
    Array.isArray(
      pickupPoints
    )
      ? pickupPoints
      : [];

  const safeDeliveryPoints =
    Array.isArray(
      deliveryPoints
    )
      ? deliveryPoints
      : [];

  const pickupStops =
    safePickupPoints.map(
      (
        point,
        index
      ) =>
        normalizeWorkspaceStop(
          point,
          "PICKUP",
          index,
          index
        )
    );

  const deliveryStops =
    safeDeliveryPoints.map(
      (
        point,
        index
      ) =>
        normalizeWorkspaceStop(
          point,
          "DELIVERY",
          index,
          pickupStops.length +
            index
        )
    );

  const combinedStops = [
    ...pickupStops,
    ...deliveryStops,
  ];

  if (
    !preserveGlobalSequence
  ) {
    return combinedStops;
  }

  return combinedStops
    .slice()
    .sort(
      compareWorkspaceStops
    )
    .map(
      (
        stop,
        index
      ) => ({
        ...stop,

        sequence:
          index,
      })
    );
}

export function buildPendentLoadMapPoints(
  workspaceStops = [],
  routeViaPoints = []
) {
  const stopPoints =
    (
      Array.isArray(
        workspaceStops
      )
        ? workspaceStops
        : []
    )
      .map(
        (
          stop,
          index
        ) => {
          const coordinates =
            getPendentLoadPointCoordinates(
              stop
            );

          if (
            !coordinates
          ) {
            return null;
          }

          return {
            ...stop,

            id:
              stop.__workspaceKey ||
              stop.id ||
              `pendent-load-map-stop-${index}`,

            type:
              stop.type,

            sequence:
              index,

            stopIndex:
              index,

            pointKind:
              "STOP",

            markerLabel:
              String(
                index +
                  1
              ),

            name:
              stop.location ||
              stop.placeName ||
              `Paragem ${index + 1}`,

            displayName:
              stop.location ||
              stop.placeName ||
              `Paragem ${index + 1}`,

            lat:
              coordinates.lat,

            lng:
              coordinates.lng,

            latitude:
              coordinates.lat,

            longitude:
              coordinates.lng,
          };
        }
      )
      .filter(
        Boolean
      );

  const normalizedViaPoints =
    normalizePendentLoadRouteViaPoints(
      routeViaPoints,
      stopPoints.length
    );

  const viasByLeg =
    new Map();

  normalizedViaPoints.forEach(
    (
      viaPoint
    ) => {
      if (
        !viasByLeg.has(
          viaPoint.legIndex
        )
      ) {
        viasByLeg.set(
          viaPoint.legIndex,
          []
        );
      }

      viasByLeg
        .get(
          viaPoint.legIndex
        )
        .push(
          viaPoint
        );
    }
  );

  const combinedPoints =
    [];

  stopPoints.forEach(
    (
      stopPoint,
      stopIndex
    ) => {
      combinedPoints.push({
        ...stopPoint,

        stopIndex,
      });

      if (
        stopIndex >=
        stopPoints.length -
          1
      ) {
        return;
      }

      const legViaPoints =
        viasByLeg.get(
          stopIndex
        ) ||
        [];

      legViaPoints.forEach(
        (
          viaPoint
        ) => {
          combinedPoints.push({
            ...viaPoint,

            type:
              "VIA",

            name:
              "Ponto de passagem",

            displayName:
              "Ponto de passagem",

            markerLabel:
              "•",

            pointKind:
              "VIA",

            viaSequence:
              viaPoint.sequence,
          });
        }
      );
    }
  );

  return combinedPoints.map(
    (
      point,
      index
    ) => ({
      ...point,

      sequence:
        index,
    })
  );
}

export function workspaceStopToPendentLoadPoint(
  workspaceStop
) {
  const {
    __workspaceKey,
    __sourceType,
    __sourceIndex,
    __sourceSequence,
    type,
    sequence,
    placeName,
    phone,
    loadAccessMode,
    ...point
  } =
    workspaceStop ||
    {};

  return {
    ...point,

    location:
      point.location ||
      placeName ||
      "",

    contactPhone:
      point.contactPhone ||
      phone ||
      "",

    loadingAccess:
      point.loadingAccess ||
      loadAccessMode ||
      null,
  };
}